import {$get,$post} from './main'

export function GetCourseDataList(params){
  return new Promise((resolve)=>{
    $post('/webapi/course/GetCourseDataList',{
      params:params
    }).then(res => {
      resolve(res.data)
    })
  })
}


export function GetUserInfo(params){//获取用户信息
    return new Promise(resolve=>{
        $get('/webapi/User/GetUserInfo',params).then(res=>{
            resolve(res.data)
        })
    })
}

/**
 *获取会员登录状态
 */
export function GetUserLoginStatus(params){
    return new Promise(resolve=>{
        $get('/plus/ajaxs.ashx?a=checkislogin&json=1',params,{
            takeUserIdAndAppToken:false
        }).then(res=>{
            resolve(res.data)
        })
    })
}
/**
 *获取课程列表
 */
export function GetMyCourseList(params){
  return new Promise((resolve)=>{
    $post('/webapi/user/GetMyCourseList',params).then(res => {
      resolve(res.data)
    })
  })
}
/**
 *获取课程试卷列表
 */
export function GetCoursePaperList(params){//获取课程列表
  return new Promise((resolve)=>{
    $post('/webapi/course/GetCoursePaperList',params).then(res => {
      resolve(res.data)
    })
  })
}
/**
 *获取我的班级列表
 */
export function GetMyRoomList(params){//获取我的班级列表
  return new Promise((resolve)=>{
    $post('/webapi/user/GetMyRoomList',params).then(res => {
      resolve(res.data)
    })
  })
}
/**
 *退出班级列表
 */
export function OutMyRoomList(params){//退出班级列表
  return new Promise((resolve)=>{
    $post('/webapi/user/OutMyRoomList',params).then(res => {
      resolve(res.data)
    })
  })
}

/**
 *获取会员卡列表
 */
export function GetAllMyDiscountCard(params){
  return new Promise((resolve)=>{
    $post('/webapi/user/GetAllMyDiscountCard',params).then(res => {
      resolve(res.data)
    })
  })
}

/**
 *获取支付列表
 */
export function GetPaymentList(params){
  return new Promise((resolve)=>{
    $post('/webapi/School/GetPaymentList',params,{
      takeUserIdAndAppToken:false
    }).then(res => {
      resolve(res.data)
    })
  })
}

/**
 *获取支付折扣卡
 */
export function DoPayDiscountCard(params){//
  return new Promise((resolve)=>{
    $post('/webapi/user/DoPayDiscountCard',params).then(res => {
      resolve(res.data)
    })
  })
}

/**
 *获取支付折扣卡
 */
export function GetDiscountCardDetial(params){//
  return new Promise((resolve)=>{
    $post('/webapi/user/GetDiscountCardDetial',params).then(res => {
      resolve(res.data)
    })
  })
}




// WEBPACK FOOTER //
// ./src/apis/user.js